module.exports = __webpack_public_path__ + "b2fc39fc56a6f4008f42697042370b5d.jpg";